module.exports = __webpack_public_path__ + "static/img/color.db409c7c.png";